"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardStyles = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      '& .MuiCardActions-root': {
        boxShadow: "inset 0 0.0625rem 0 0 ".concat(theme.palette.secondary.border),
        height: '3.625rem' // padding: '2.125rem 1.5rem',
        // padding: '1.0625rem 1.5rem',

      },
      '& .MuiTypography-h6': {
        opacity: function opacity(_ref) {
          var disabled = _ref.disabled;
          return disabled ? '50%' : '1';
        }
      },
      '& .MuiTypography-subtitle2': {
        flexBasis: '65%',
        opacity: function opacity(_ref2) {
          var disabled = _ref2.disabled;
          return disabled ? '50%' : '1';
        }
      },
      '& img': {
        // marginTop: '-2.25rem',
        maxHeight: '6rem',
        maxWidth: '6rem',
        opacity: function opacity(_ref3) {
          var disabled = _ref3.disabled;
          return disabled ? '50%' : '1';
        }
      },
      backgroundColor: theme.palette.background.white,
      borderRadius: '1rem;',
      boxShadow: ' 0 1.5rem 5rem 0 rgba(34, 34, 34, 0.08);',
      height: '100%'
    }
  };
})(_Card.default);
var _default = CardStyles;
exports.default = _default;